import { UserModel } from './user';
export interface UserListModel {
  count: number;
  next: string;
  previous: string;
  results: UserModel[];
}
